import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';

import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { ProjectInsightsService } from '../insights.service';
import { RelatedToType } from 'app/shared/enums';

@Component({
  selector: 'project-insights-add-compset',
  templateUrl: './add-compset.component.html',
  styleUrls: ['./add-compset.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProjectInsightsAddCompsetComponent extends OnDestroyMixin implements OnInit {
  public addCompsetForm: UntypedFormGroup;
  public isLoading: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { type: RelatedToType; compset_type: string },
    public readonly matDialogRef: MatDialogRef<ProjectInsightsAddCompsetComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly projectInsightsService: ProjectInsightsService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm(): void {
    this.addCompsetForm = this.formBuilder.group({
      title: ['', [Validators.required]],
      object_type: [this.data.type],
      compset_type: [this.data.compset_type],
    });
  }

  public get isSaveBtnDisabled(): boolean {
    return this.isLoading || this.addCompsetForm.pristine || this.addCompsetForm.invalid;
  }

  public discard(): void {
    this.matDialogRef.close();
  }

  public save(): void {
    const vals = this.addCompsetForm.value;
    this.projectInsightsService
      .saveCompset(vals)
      .pipe(untilComponentDestroyed(this))
      .subscribe((res) => {
        this.matDialogRef.close(res);
      });
  }

  // Function attached to debounce-click directive to flag the button's disable state.
  public isDebounceLoading(isLoading: boolean): boolean {
    return (this.isLoading = isLoading);
  }
}
